import { ReactElement } from 'react';
import { Snackbar } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';
import * as S from './styles';

type ToastProps = {
  message: string;
  onClose: () => void;
  open: boolean;
  severity: 'success' | 'warning';
};

/**
 * ユーザーに簡単なフィードバックを通知するコンポーネント
 * 5秒後に消えるため重要ではない場合のみ使用する
 *
 * @param message 通知するメッセージ
 * @param onClose コンポーネントを閉じるリクエストがされたときに発火(e.g. 表示から5秒後)
 * @param open コンポーネントの開閉状態を制御
 * @param severity 通知の種別
 */
export function Toast({
  message,
  onClose,
  open,
  severity,
}: ToastProps): ReactElement {
  return (
    <Snackbar
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      autoHideDuration={2000}
      key={message}
      open={open}
      onClose={onClose}
      sx={{ maxWidth: '100%' }}
    >
      <S.StyledAlert
        elevation={4}
        iconMapping={{
          success: <CheckCircleIcon color="inherit" />,
          warning: <WarningIcon color="progress" />,
        }}
        severity={severity}
      >
        {message}
      </S.StyledAlert>
    </Snackbar>
  );
}
